'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Accordion = require('react-bootstrap/lib/Accordion');

var _Accordion2 = _interopRequireDefault(_Accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Accordion2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Accordion.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Accordion.js
 ** module chunks = 0
 **/